export const CHIP_VARIANT = {
  CONTAINED: 'contained',
  OUTLINED: 'outlined',
  ICON: 'icon',
  FILTER: 'filter',
  FILTER_AVATAR: 'filter_avatar',
  LARGE: 'large',
  LARGE_ICON: 'large_icon',
  SELECTABLE_CONTAINED: 'selectable_contained',
}

export const CHIP_SIZE = {
  LARGE: 'large',
  MEDIUM: 'medium',
  SMALL: 'small',
}
